import { baseColumns } from '../../ActionsScreen/AdminActionsScreen/constants';

export const CHALLENGE_ACTIONS_TABLE_COLUMNS = [
    ...baseColumns,
    {
        accessor: 'actions',
    },
];
